export enum Step {
    Info = 'INFO',
    Pin = 'PIN',
    Success = 'SUCCESS'
}
